export const MAX_POLL_ATTEMPTS = 5;
export const MAX_POLL_USER_ATTEMPTS = 3;
